/**
 * Retail-site detection for the incident screens.
 *
 * Retail stores drop several things the other site types keep: the Critical
 * flag (and its filter), the Remedy reference, the priority, and any problem
 * category not flagged visible-on-retail. All of that keys off this one check.
 *
 * `guardingType` ('retail' / 'non_retail') is the authoritative value and comes
 * straight from the site type. The site type's NAME is only a fallback for
 * responses that predate the field — matching on the name is fragile because an
 * admin can rename a site type at any time.
 */
export interface RetailSiteLookup {
    siteTypes: Record<string, string>;
    siteGuardingTypes?: Record<string, string>;
}

export const RETAIL_GUARDING_TYPE = 'retail';

/**
 * Whether the given site id refers to a retail store.
 */
export const isRetailSiteId = (lookup: RetailSiteLookup, siteValue: string): boolean => {
    if (!siteValue) return false;

    const guardingType = lookup.siteGuardingTypes?.[siteValue];
    if (guardingType) return guardingType.toLowerCase() === RETAIL_GUARDING_TYPE;

    return lookup.siteTypes[siteValue]?.toLowerCase() === RETAIL_GUARDING_TYPE;
};
